// A single, user-initiated location reading. Roadrunner never watches position.

export type GeoFailure = 'unsupported' | 'denied' | 'unavailable' | 'timeout';

export class GeoError extends Error {
  readonly reason: GeoFailure;
  constructor(reason: GeoFailure) {
    super(reason);
    this.reason = reason;
  }
}

export function readPositionOnce(): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new GeoError('unsupported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      resolve,
      (error) => {
        const reason: GeoFailure =
          error.code === error.PERMISSION_DENIED ? 'denied' : error.code === error.TIMEOUT ? 'timeout' : 'unavailable';
        reject(new GeoError(reason));
      },
      { enableHighAccuracy: true, timeout: 20_000, maximumAge: 0 },
    );
  });
}

export const GEO_MESSAGES: Record<GeoFailure, string> = {
  unsupported: "This browser can't share its location. Try Safari or Chrome on your phone.",
  denied:
    'Location access is turned off for Roadrunner. Allow location for this site in your browser settings, then try again.',
  unavailable:
    "Your device couldn't find its location. If you're on a computer, try your phone instead. On a phone, step near a window or outside and try again.",
  timeout: 'Finding your location took too long. Try again, ideally on your phone.',
};
